/* Oat-mazing on Shopify (Huemankind for Love Earth, 2026-10-15).
   The reviewed bundle builder runs unchanged; this file only hands the picked packs to Shopify's own cart and checkout.
   - Products are found by handle at run time (window.OAT_SHOPIFY.handles), so no variant id is written into the theme. If any product is
     missing, unpublished or sold out, nothing is added and the shopper is told ordering opens soon.
   - Free packs and free delivery are Shopify discounts and shipping rates set up in the admin (SETUP.md); the page's own totals are the
     promise, and the pre-launch test orders in SETUP.md check that checkout matches them.
   - Free packs (4 packs = 1 free, 7 packs = 2 free, the 11.11 promo is always on) are automatic Shopify discounts; no code is needed.
   - The RM5 sign-up code (oat-signup.js keeps it on this device after a sign-up) is added at checkout; it stacks with the free packs.
   - Subscribe & save is offered only when the theme setting is on; otherwise the page is held to one-time purchase.
   This is a classic script placed before the page's module script, so it runs first. */
(() => {
  const cfg = window.OAT_SHOPIFY || {}, handles = cfg.handles || {};
  const BASKET = 'oatmazing:earth-city:bundle:v6', BUY = 'oatmazing:buy-type';
  const zh = (document.documentElement.lang || '').startsWith('zh');
  const T = zh
    ? {wait: '正在准备结账…', soon: '网上订购即将开放，请稍后再来。', fail: '没能打开结账页面，请再试一次。', empty: '请先选几包。'}
    : {wait: 'Getting your checkout ready…', soon: 'Online ordering opens soon. Please check back shortly.', fail: 'Checkout did not open. Please try again.', empty: 'Pick some packs first.'};
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  if (!cfg.subscriptions) { try { localStorage.setItem(BUY, 'once'); } catch { /* storage is optional */ } }
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const found = {};   // product id -> {variant, plan}
  const ready = Promise.all(Object.entries(handles).map(async ([id, handle]) => {
    const r = await fetch(`${root()}products/${encodeURIComponent(handle)}.js`, {headers: {Accept: 'application/json'}});
    if (!r.ok) throw new Error(`product ${handle}: HTTP ${r.status}`);
    const p = await r.json();
    const v = (p.variants || []).find(x => x.available);
    if (!v) throw new Error(`product ${handle}: not available`);
    const plan = cfg.subscriptions ? ((p.selling_plan_groups || [])[0]?.selling_plans?.[0]?.id ?? null) : null;
    found[id] = {variant: v.id, plan};
  }));
  ready.catch(e => console.warn('[oat-checkout]', e.message));

  const say = msg => document.querySelectorAll('[data-checkout-status]').forEach(n => { n.textContent = msg; });
  const post = async (path, body) => {
    const r = await fetch(root() + path, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    if (!r.ok) throw new Error(`${path}: HTTP ${r.status}`);
    return r.json();
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-shopify-checkout]');
    if (!button || button.disabled) return;
    let basket = {};
    try { basket = JSON.parse(read(BASKET)) || {}; } catch { basket = {}; }
    const picked = Object.entries(basket).filter(([id, q]) => handles[id] && Number.isSafeInteger(q) && q > 0);
    if (!picked.length) { say(T.empty); return; }
    const sub = Boolean(cfg.subscriptions) && read(BUY) === 'sub';
    button.disabled = true; say(T.wait);
    try { await ready; } catch { say(T.soon); button.disabled = false; return; }
    const items = picked.map(([id, quantity]) => ({id: found[id].variant, quantity, ...(sub ? {selling_plan: found[id].plan} : {})}));
    if (sub && items.some(item => !item.selling_plan)) { say(T.fail); button.disabled = false; return; }
    try {
      await post('cart/clear.js', {});
      await post('cart/add.js', {items, attributes: {'Bundle source': 'oat-mazing one-page'}});
      const code = (read('oatmazing:welcome-code') || '').trim();
      const target = code && code === (cfg.welcomeCode || '').trim() ? `checkout?discount=${encodeURIComponent(code)}` : 'checkout';
      location.assign(root() + target);
    } catch (e) {
      console.warn('[oat-checkout]', e.message); say(T.fail); button.disabled = false;
    }
  });
})();
